import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Courses = () => {
  const { t } = useLanguage();
  return (
    <div className="page-container">
      <h1>{t.Cours_scolaire}</h1>
      <p>Page Cours Scolaire - ATC</p>
    </div>
  );
};

export default Courses;